import React, { PureComponent } from 'react'
import Icon from '@mdi/react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import packageJson from '../../package.json'
import GatewayStatusBadge from './GatewayStatusBadge'
import VoiceNoteButton from './VoiceNoteButton'

import { 
    mdiAngleAcute,
    mdiAngleRight,
    mdiArrowSplitHorizontal,
    mdiEyeOff,
    mdiCheckboxIntermediate,
    mdiWhiteBalanceSunny,
    mdiCursorDefault, 
    mdiCursorPointer,
    mdiEllipse,
    mdiEyedropper,
    mdiGesture,
    mdiMagnify,
    mdiMonitor,
    mdiRectangle,
    mdiRuler,
    mdiVectorLink,
  } from '@mdi/js'

const styleTable = {
  borderCollapse: 'collapse',
  width: '120px',
  height: '120px',
}

const styleTableTd = {
  width: '40px',
  height: '40px',
  padding: '3px',
  //border: 'solid 1px black',
}

const iconSize = '1.2rem'
const iconColor = '#FFFFFF'
const activeColor = 'rgba(0, 255, 0, 1.0)'

class ToolsPanel extends PureComponent {
    constructor(props) {
      super(props)
      this.tableRef = React.createRef()
    }

    componentDidMount() {
      
    }

    colorIcon = (tool) => {
        return this.props.toolActive === tool ? activeColor : iconColor
    }
    
    render() {  
      return (
        <div>            
            <table style={styleTable} ref={this.tableRef}>
                <tbody>
                <tr>
                    <td style={styleTableTd}>
                        <Tooltip title="No Tool">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('notool')}>
                                <Icon path={mdiCursorDefault} size={iconSize} color={this.colorIcon('notool')} />
                            </IconButton>
                        </Tooltip>
                    </td>
                    {this.props.showReferenceLines !== false ? (
                    <td style={styleTableTd}>
                        <Tooltip title="Reference Lines">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('referencelines')}>
                                <Icon path={mdiArrowSplitHorizontal} size={iconSize} color={this.props.referenceLines ? activeColor : iconColor} />
                            </IconButton>
                        </Tooltip>
                    </td>
                    ) : null}
                    {this.props.showReferenceLines !== false && this.props.referenceLines ? (
                    <td style={styleTableTd}>
                        <Tooltip title="Ocultar línea en viewport activo">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('referencelinesactivehide')}>
                                <Icon path={mdiEyeOff} size={iconSize} color={this.props.hideReferenceLinesOnActive ? activeColor : iconColor} />
                            </IconButton>
                        </Tooltip>
                    </td>
                    ) : null}
                    <td style={styleTableTd}>
                        <Tooltip title="Link Series">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('serieslink')} disabled={!!this.props.mprActive}>
                                <Icon path={mdiVectorLink} size={iconSize} color={this.props.seriesLink ? activeColor : iconColor} />
                            </IconButton>
                        </Tooltip>
                    </td>
                    <td style={styleTableTd}>
                        {this.props.seriesLink || this.props.mprActive ? (
                          <Tooltip title={this.props.mprActive ? 'Link WW/WL (planos MPR)' : 'Link WW/WL'}>
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('serieslinkwwwc')}>
                                <Icon path={mdiWhiteBalanceSunny} size={iconSize} color={this.props.seriesLinkWwwc ? activeColor : iconColor} />
                            </IconButton>
                          </Tooltip>
                        ) : null}
                    </td> 
                </tr>   
                <tr>
                    <td style={styleTableTd}>
                        <Tooltip title="WW/WC">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('Wwwc')}>
                                <Icon path={mdiWhiteBalanceSunny} size={iconSize} color={this.colorIcon('Wwwc')} />
                            </IconButton>
                        </Tooltip>
                    </td>    
                    <td style={styleTableTd}>
                        <Tooltip title="Pan">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('Pan')}>
                                <Icon path={mdiCursorPointer} size={iconSize} color={this.colorIcon('Pan')} />
                            </IconButton>
                        </Tooltip>
                    </td>
                    <td style={styleTableTd}>
                        <Tooltip title="Zoom">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('Zoom')}>
                                <Icon path={mdiMagnify} size={iconSize} color={this.colorIcon('Zoom')} />
                            </IconButton>
                        </Tooltip>
                    </td>                                    
                </tr>
                <tr>
                    <td style={styleTableTd} colSpan={3}>
                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                          <VoiceNoteButton
                            holdToTalk={false}
                            recording={!!this.props.voiceNoteRecording}
                            busy={!!this.props.voiceNoteBusy}
                            disabled={this.props.anyOpen === false}
                            iconSize={iconSize}
                            color={iconColor}
                            onToggle={this.props.onVoiceNoteToggle}
                            onStart={this.props.onVoiceNoteStart}
                            onStop={this.props.onVoiceNoteStop}
                          />
                        </div>
                    </td>
                </tr>
                <tr>
                    <td style={styleTableTd}>
                        <Tooltip title="Magnify">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('Magnify')}>
                                <Icon path={mdiCheckboxIntermediate} size={iconSize} color={this.colorIcon('Magnify')} />
                            </IconButton>
                        </Tooltip>
                    </td>   
                    <td style={styleTableTd}>
                        <Tooltip title="Length">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('Length')}>
                                <Icon path={mdiRuler} size={iconSize} color={this.colorIcon('Length')} />
                            </IconButton>
                        </Tooltip>
                    </td>
                    <td style={styleTableTd}>
                        <Tooltip title="Probe">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('Probe')}>
                                <Icon path={mdiEyedropper} size={iconSize} color={this.colorIcon('Probe')} />
                            </IconButton>
                        </Tooltip>
                    </td>                    
                </tr> 
                <tr>
                    <td style={styleTableTd}>
                        <Tooltip title="Angle">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('Angle')}>
                                <Icon path={mdiAngleAcute} size={iconSize} color={this.colorIcon('Angle')} />
                            </IconButton>
                        </Tooltip>
                    </td>   
                    <td style={styleTableTd}>
                        <Tooltip title="Cobb Angle">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('CobbAngle')}>
                                <Icon path={mdiAngleRight} size={iconSize} color={this.colorIcon('CobbAngle')} />
                            </IconButton>
                        </Tooltip>
                    </td>   
                    <td style={styleTableTd}>
                        <Tooltip title="Elliptical Roi">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('EllipticalRoi')}>
                                <Icon path={mdiEllipse} size={iconSize} color={this.colorIcon('EllipticalRoi')} />
                            </IconButton>
                        </Tooltip>
                    </td>
                    <td style={styleTableTd}>
                        <Tooltip title="Rectangle Roi">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('RectangleRoi')}>
                                <Icon path={mdiRectangle} size={iconSize} color={this.colorIcon('RectangleRoi')} />
                            </IconButton>
                        </Tooltip>
                    </td>                    
                </tr> 
                <tr>
                    <td style={styleTableTd}>
                        <Tooltip title="Freehand Roi">
                            <IconButton color="inherit" onClick={() => this.props.toolExecute('FreehandRoi')}>
                                <Icon path={mdiGesture} size={iconSize} color={this.colorIcon('FreehandRoi')} />
                            </IconButton>
                        </Tooltip>
                    </td>
                    <td style={styleTableTd}>
                      {this.props.onGsdfQa ? (
                        <Tooltip title="QA de pantalla (GSDF)">
                          <IconButton color="inherit" onClick={() => this.props.onGsdfQa()}>
                            <Icon
                              path={mdiMonitor}
                              size={iconSize}
                              color={this.props.gsdfQaPassed ? activeColor : '#ffca28'}
                            />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                    </td>
                </tr>                                                               
                </tbody>
            </table>

            <div
              style={{
                marginTop: 8,
                paddingBottom: 4,
                textAlign: 'center',
                userSelect: 'none',
              }}
            >
              <GatewayStatusBadge
                status={this.props.gatewayStatus || 'local_only'}
                compatOk={this.props.gatewayCompatOk !== false}
                onClick={() => {
                  if (typeof this.props.onGatewayOpen === 'function') {
                    this.props.onGatewayOpen()
                  } else if (typeof this.props.onGateway === 'function') {
                    this.props.onGateway()
                  }
                }}
                style={{
                  display: 'block',
                  width: '100%',
                  marginBottom: 4,
                  padding: '2px 4px',
                  borderRadius: 3,
                  fontSize: 8,
                  fontWeight: 600,
                  letterSpacing: 0.2,
                  cursor: 'pointer',
                }}
              />
              {this.props.onGsdfQa ? (
                <button
                  type="button"
                  onClick={() => this.props.onGsdfQa()}
                  aria-label={
                    this.props.gsdfQaPassed ? 'QA Screen: OK' : 'QA Screen: Unverified'
                  }
                  style={{
                    display: 'block',
                    width: '100%',
                    marginBottom: 4,
                    padding: '2px 4px',
                    borderRadius: 3,
                    border: '1px solid',
                    borderColor: this.props.gsdfQaPassed
                      ? 'rgba(76, 175, 80, 0.4)'
                      : 'rgba(255, 193, 7, 0.4)',
                    background: this.props.gsdfQaPassed
                      ? 'rgba(76, 175, 80, 0.15)'
                      : 'rgba(255, 193, 7, 0.12)',
                    color: this.props.gsdfQaPassed ? '#a5d6a7' : '#ffe082',
                    fontSize: 8,
                    fontWeight: 600,
                    letterSpacing: 0.2,
                    cursor: 'pointer',
                  }}
                >
                  {this.props.gsdfQaPassed ? 'QA Screen: OK' : 'QA Screen: Unverified'}
                </button>
              ) : null}
              <div
                aria-label={`Versión ${packageJson.version}`}
                style={{
                  fontSize: 9,
                  letterSpacing: 0.4,
                  color: 'rgba(255, 255, 255, 0.4)',
                }}
              >
                v{packageJson.version}
              </div>
            </div>
        </div>     
      )
    }

}

export default ToolsPanel
